// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"775":"gsap","9508":"ScrollTrigger"}[chunkId] + "." + {"775":"424121281d5a865eeafe","9508":"cb272f183736f7b0057f"}[chunkId] + ".js";
};